module.exports = __webpack_public_path__ + "7140f4ef9e1171a1ac57cc08a770b209.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/header.png
// module id = 2154
// module chunks = 0